<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div v-if="!projectPlanning">
      <input v-if="showWorkloadPlanner" type="number" min="0" max="9999"
        :disabled="timeframe != 'week' || dateIndex < actualDate || calculatedHours > 0" class="work-load-planner"
        @input="updatePlannedWorkload(plannedHours)" v-model.number="plannedHours" @focus="$event.target.select()">
      <span @mouseleave="mouseLeave" data-placement="right" data-html="true" data-trigger="click" data-toggle="tooltip"
        :title="tooltip(plannedWorkload.projects)"
        :class="{ 'zero-value': !plannedWorkload.totalPlanned && !plannedWorkload.totalCalculated, 'project-tooltip': plannedWorkload.projects }"
        v-if="showTotalPlanned">
        {{ Math.round((plannedWorkload.totalPlanned + plannedWorkload.totalCalculated) / 3600) }}
        <!--<span class="tooltiptext" v-if="plannedWorkload.projects">-->
        <!--<div v-for="(planned, projectId) in plannedWorkload.projects">{{projects[projectId].name}}: {{(planned.plannedTime/3600).toFixed(0)}} + {{(planned.calculatedTime/3600).toFixed(0)}}</div>-->
        <!--</span>-->
      </span>
    </div>
    <div :class="{ 'text-right': dateIndex >= actualDate }" v-if="projectPlanning">
      <input v-if="showWorkloadPlanner && dateIndex >= actualDate && (plannedHours >= 0 && calculatedHours == 0)"
        :disabled="timeframe != 'week' || dateIndex < actualDate" class="work-load-planner text-right"
        @input="updatePlannedWorkload(plannedHours)" v-model.number="plannedHours" @focus="$event.target.select()">
      <input v-if="showWorkloadPlanner && dateIndex >= actualDate && (calculatedHours > 0)" class="work-load-planner"
        v-model.number="totalPlannedHours" disabled>
      <!--<span :class="{'zero-value': !plannedWorkload.totalPlanned && !plannedWorkload.totalCalculated, 'project-tooltip': plannedWorkload.projects}" v-if="showTotalPlanned && ((plannedWorkload.totalPlanned + plannedWorkload.totalCalculated) != 0)">-->
      <!--<div v-for="(planned, index) in plannedWorkload.projects">-->
      <!--<span v-if="index == projectId" class="planned-number">{{Math.round((plannedWorkload.projects[projectId].plannedTime + plannedWorkload.projects[projectId].calculatedTime) / 3600)}}</span>-->
      <!--<span class="tooltiptext" v-if="plannedWorkload.projects">-->
      <!--<div>-->
      <!--<small v-if="index == projectId">Project name: Planned hours + calculated hours <br></small>-->
      <!--<small v-if="index == projectId">{{projects[index].name}}: {{(plannedWorkload.projects[projectId].plannedTime/3600).toFixed(0)}} + {{(plannedWorkload.projects[projectId].calculatedTime/3600).toFixed(0)}} </small>-->
      <!--</div>-->
      <!--</span>-->
      <!--</div>-->
      <!--</span>-->
    </div>
    <div @mouseleave="mouseLeave" :class="{ 'text-right': dateIndex >= actualDate }"
      v-if="projectPlanning && dateIndex >= actualDate">
      <span data-placement="left" data-html="true" data-trigger="click focus" data-toggle="tooltip"
        :title="tooltip(plannedWorkload.projects)"
        :class="{ 'zero-value': !plannedWorkload.totalPlanned && !plannedWorkload.totalCalculated, 'total-user-planned-hours-number': plannedWorkload.totalPlanned || plannedWorkload.totalCalculated, 'project-tooltip': plannedWorkload.projects }"
        v-if="showTotalPlanned && (plannedWorkload.totalPlanned || plannedWorkload.totalCalculated)">
        {{ ((plannedWorkload.totalPlanned + plannedWorkload.totalCalculated) / 3600).toFixed(2) }}
        <!--<span class="tooltiptext" v-if="plannedWorkload.projects">-->
        <!--<div v-for="(planned, projectId) in plannedWorkload.projects"><small>{{projects[projectId].name}}: {{(planned.plannedTime/3600).toFixed(2)}} + {{(planned.calculatedTime/3600).toFixed(2)}}</small></div>-->
        <!--</span>-->
      </span>
    </div>
    <div v-if="showPlannedExpenses && !projectPlanning"
      :class="{ 'zero-value': (!plannedHours && !plannedWorkload.totalCalculated) || !ratesOnDate(datesByYearweek[dateIndex], userId) }"
      class="currency">{{ ((plannedHours + (plannedWorkload.totalCalculated / 3600)) *
          ratesOnDate(datesByYearweek[dateIndex], userId)).toFixed(2)
      }}</div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'WorkloadPlanningCell',
  props: ['userId', 'projectId', 'dateIndex', 'showPlannedExpenses', 'showWorkloadPlanner', 'showTotalPlanned', 'timeframe', 'projectPlanning', 'plannedWorkload'],
  data: function () {
    return {
      plannedHours: 0,
      calculatedHours: 0,
      totalPlanned: {},
    };
  },
  watch: {
    dateIndex: function () { this.setInitialHours(); },
    timeframe: function () { this.setInitialHours(); },
    plannedWorkload: function () { this.setInitialHours(); },
  },
  components: {

  },
  computed: {
    ...mapGetters('WorkloadPlans', [
      'workloadsByProjectByUserByYearweek',
      'workloads',
      'workloadsByUserByYearweekByProject',
      'workloadsByUserByMonthByProject',
      'workloadsByUserByQuarterByProject',
      'workloadsByUserByYearByProject',
    ]),
    ...mapGetters('Worklogs', [
      'datesByYearweek', 'weekOffset', 'weekCount', 'actualDate'
    ]),
    ...mapGetters('UserRates', [
      'ratesOnDate',
    ]),
    ...mapGetters('JiraProjects', [
      'projects',
    ]),
  },
  methods: {
    mouseLeave() {
      // $('[data-toggle="tooltip"]').tooltip('hide');
    },
    tooltip(projects) {
      let tooltipMessage = '';
      for (const i in projects) {
        let projText = `<small>${this.projects[i].name}: `;
        projText += `${(projects[i].plannedTime / 3600).toFixed(2)} + ${(projects[i].calculatedTime / 3600).toFixed(2)}</small><br>`;
        tooltipMessage += projText;
      }
      return tooltipMessage;
    },
    ...mapActions('WorkloadPlans', [
      'UPDATE_PLANNED_WORKLOAD', 'LOAD_PLANNED_WORKLOADS'
    ]),
    updatePlannedWorkload(plannedHours) {
      this.UPDATE_PLANNED_WORKLOAD({ plannedSeconds: plannedHours * 3600, user_id: this.userId, project_id: this.projectId, date: this.dateIndex, uid: this._uid });
    },
    setInitialHours() {
      if (this.plannedWorkload.projects && this.plannedWorkload.projects[this.projectId]) {
        this.plannedHours = parseFloat(this.plannedWorkload.projects[this.projectId].plannedTime) / 3600;
        this.calculatedHours = parseFloat(this.plannedWorkload.projects[this.projectId].calculatedTime) / 3600;
        this.totalPlannedHours = (this.plannedHours + this.calculatedHours).toFixed(2);
      } else {
        this.plannedHours = 0;
      }
    }
  },
  mounted() {
    const _this = this;
    // $(() => {
    //   $('[data-toggle="tooltip"]').tooltip();
    // });
    this.setInitialHours();
    window.EventBus.$on(`update-planned-workload-${this._uid}`, (data) => {
      _this.setInitialHours();
    });
  },
};
</script>
<style scoped>
.align-left {
  text-align: left;
  padding-left: 5px;
}

.planned-number {
  font-weight: bold;
  color: #005ef7;
}

.total-user-planned-hours-number {
  color: blueviolet;
}

.work-load-planner {
  line-height: normal;
}

input.work-load-planner {
  width: 50px;
}

.currency::after {
  content: "€";
}

.project-tooltip {
  position: relative;
  display: inline-block;
  /*border-bottom: 1px dotted black;*/
}

.project-tooltip .tooltiptext {
  visibility: hidden;
  width: 400px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  /*top: 100%;*/
  left: 50%;
  bottom: 50%;
  margin-left: -125px;
}

.project-tooltip:hover .tooltiptext {
  visibility: visible;
}

.zero-value {
  color: silver;
}
</style>
